import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M15_TOPICS, M15_MODULE_INFO } from '../data/mathExercises/M15_Trigonometry';

// Create mock problems data for M15
const M15_PROBLEMS_DATA = {
  'M15_01': [
    {
      id: 'M15_01_P001',
      topicId: 'M15_01',
      question: "將 120° 轉換為弧度制",
      solution: "2π/3 弧度",
      explanation: "使用角度與弧度的轉換公式",
      difficulty: 1,
      order: 1,
      steps: ["轉換公式：弧度 = 角度 × π/180°", "代入 120°", "120° × π/180° = 2π/3 弧度"]
    },
    {
      id: 'M15_01_P002',
      topicId: 'M15_01',
      question: "求 sin 30°, cos 30°, tan 30° 的值",
      solution: "sin 30° = 1/2, cos 30° = √3/2, tan 30° = √3/3",
      explanation: "記憶特殊角的三角函數值",
      difficulty: 1,
      order: 2,
      steps: ["30° 是特殊角", "利用直角三角形或單位圓", "sin 30° = 1/2, cos 30° = √3/2, tan 30° = √3/3"]
    }
  ],
  'M15_02': [
    {
      id: 'M15_02_P001',
      topicId: 'M15_02',
      question: "證明恆等式：sin²θ + cos²θ = 1",
      solution: "畢氏定理的應用",
      explanation: "基本三角恆等式的證明",
      difficulty: 2,
      order: 1,
      steps: ["在單位圓中，設點 P(cos θ, sin θ)", "點 P 到原點的距離為 1", "由距離公式：cos²θ + sin²θ = 1"]
    }
  ],
  'M15_03': [
    {
      id: 'M15_03_P001',
      topicId: 'M15_03',
      question: "畫出 y = sin x 在 [0, 2π] 的圖像，並標出關鍵點",
      solution: "週期為 2π 的正弦波",
      explanation: "正弦函數的圖像特徵",
      difficulty: 2,
      order: 1,
      steps: ["關鍵點：(0,0), (π/2,1), (π,0), (3π/2,-1), (2π,0)", "連接成光滑曲線", "週期 = 2π，振幅 = 1"]
    }
  ],
  'M15_04': [
    {
      id: 'M15_04_P001',
      topicId: 'M15_04',
      question: "利用兩角和公式計算 sin 75°",
      solution: "sin 75° = (√6 + √2)/4",
      explanation: "sin 75° = sin(45° + 30°)",
      difficulty: 2,
      order: 1,
      steps: ["sin 75° = sin(45° + 30°)", "sin(A + B) = sin A cos B + cos A sin B", "= sin 45° cos 30° + cos 45° sin 30°", "= (√2/2)(√3/2) + (√2/2)(1/2) = (√6 + √2)/4"]
    }
  ],
  'M15_05': [
    {
      id: 'M15_05_P001',
      topicId: 'M15_05',
      question: "解方程：sin x = 1/2，x ∈ [0, 2π]",
      solution: "x = π/6 或 x = 5π/6",
      explanation: "基本三角方程的求解",
      difficulty: 2,
      order: 1,
      steps: ["sin x = 1/2", "在 [0, 2π] 中，正弦值為 1/2 的角", "x = π/6 和 x = 5π/6"]
    }
  ],
  'M15_06': [
    {
      id: 'M15_06_P001',
      topicId: 'M15_06',
      question: "求函數 f(x) = 2sin x 的週期、振幅和值域",
      solution: "週期 2π，振幅 2，值域 [-2, 2]",
      explanation: "三角函數性質的分析",
      difficulty: 2,
      order: 1,
      steps: ["標準形式：f(x) = A sin(Bx + C) + D", "A = 2（振幅），B = 1", "週期 = 2π/B = 2π", "值域 = [-2, 2]"]
    }
  ],
  'M15_07': [
    {
      id: 'M15_07_P001',
      topicId: 'M15_07',
      question: "計算 arcsin(1/2) 的值",
      solution: "π/6",
      explanation: "反正弦函數的計算",
      difficulty: 2,
      order: 1,
      steps: ["arcsin(1/2) 表示正弦值為 1/2 的角", "在 [-π/2, π/2] 範圍內", "arcsin(1/2) = π/6"]
    }
  ],
  'M15_08': [
    {
      id: 'M15_08_P001',
      topicId: 'M15_08',
      question: "在三角形 ABC 中，a = 8, b = 6, C = 60°，求邊 c",
      solution: "c = 2√7",
      explanation: "餘弦定理的應用",
      difficulty: 3,
      order: 1,
      steps: ["餘弦定理：c² = a² + b² - 2ab cos C", "代入 a = 8, b = 6, C = 60°", "c² = 64 + 36 - 96 × (1/2) = 52", "c = 2√7"]
    }
  ]
};

const M15TrigonometryExercise = ({ onProgress }) => {
  // Convert problemsData to flat problems array
  const problems = Object.values(M15_PROBLEMS_DATA).flat();
  
  return (
    <ExerciseInterface
      moduleInfo={M15_MODULE_INFO}
      topics={M15_TOPICS}
      problems={problems}
      onProgress={onProgress}
      className="m15-exercise"
    />
  );
};

export default M15TrigonometryExercise; 